<template>
    <div name="faq" class="faq" id="accordion">
        <div class="faq-inner">
            <div class="faq-wrap" v-for="(faq, index) in faqData" :key="index">
                <button type="button" class="faq-card" @click="open(index)">
                    <strong class="card-title">
                        <span class="question">Q</span>{{ faq.title }}
                    </strong>
                    <img
                        style="width: 12px"
                        v-if="selected !== index"
                        src="../../assets/partners_pc/ico_plus.png"
                        alt="열기"
                    />
                    <img
                        style="width: 12px"
                        v-else
                        src="../../assets/partners_pc/ico_minus.png"
                        alt="닫기"
                    />
                </button>
                <transition
                    name="accordion"
                    @enter="start"
                    @after-enter="end"
                    @before-leave="start"
                    @after-leave="end"
                >
                    <div class="faq-content" v-show="selected === index">
                        <div class="inner">
                            {{ faq.content }}
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <a
            href="https://soldoc.channel.io/home"
            target="_blank"
            title="새창으로 열림"
            class="btn-faq"
            >문의하기</a
        >
    </div>
</template>

<script>
export default {
    name: "faq",
    data: function() {
        return {
            selected: 0,
            faqData: [
                {
                    title: "솔닥파트너스 가입 절차가 어떻게 되나요?",
                    content:
                        "솔닥파트너스는 페이지 내 [ 무료 가입하기 ]를 통해 직접 가입을 진행할 수 있으며 약 2 영업일 내 솔닥에서 정보 확인 후 가입이 최종 승인됩니다.",
                },
                {
                    title:
                        "솔닥파트너스는 어떤 의료기관에서 사용이 가능한가요?",
                    content: "모든 의료기관에서 사용 가능합니다.",
                },
                {
                    title: "비용은 어떻게 되나요?",
                    content:
                        "현재 모든 가입자 무료 프로모션 진행 중이며, 추후 비용 업데이트 시 안내드리겠습니다.",
                },
                {
                    title: "가입 조건이 따로 있나요?",
                    content:
                        "현재 병·의원 또는 약국을 운영하고 있는 의사선생님, 약사님이라면 모두 가입 가능합니다.",
                },
                {
                    title: "보다 자세한 이용 방법이 궁금해요.",
                    content:
                        "솔루션 이용 방법은 가입완료 후 전달드리는 이용가이드를 참고해 주시기 바랍니다. 서비스에 대한 더 자세한 안내가 필요하다면 솔닥파트너스 전담 고객센터로 연락주세요. 친절히 상담드리겠습니다. (고객센터 전화번호: 02-6954-7676)",
                },
            ],
        };
    },
    methods: {
        open(index) {
            this.selected = this.selected === index ? null : index;
        },
        start(el) {
            el.style.height = el.scrollHeight + "px";
        },
        end(el) {
            el.style.height = "";
        },
    },
    // props: {},
    // data: function() {
    //     return {
    //         selected: 1,
    //         // index: null,
    //         // Accordion: {
    //         //     count: 0,
    //         //     active: null,
    //         // },
    //     };
    // },
    // provide() {
    //     // return { Accordion: this.Accordion };
    // },
    // computed: {
    //     visible() {
    //         return this.index === this.selected;
    //     },
    // },
    // methods: {
    //     open(index) {
    //         if (this.selected === index) {
    //             this.selected = null; // 이미 열린 항목을 닫음
    //         } else {
    //             this.selected = index; // 새로운 항목을 엶
    //         }
    //     },
    //     start(el) {
    //         el.style.height = el.scrollHeight + "px";
    //     },
    //     end(el) {
    //         el.style.height = "";
    //     },
    // },
};
</script>

<style scoped>
.faq {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding-bottom: 130px;
    background: #1a1a1a;
}

.faq-inner {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 1200px;
    padding: 148px 0 0;
    border-bottom: 1px solid #9da0a4;
}

.in {
    margin-left: 30px;
}

.faq .btn-faq {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 114px;
    height: 48px;
    margin-top: 64px;
    border: 1px solid #fff;
    border-radius: 4px;
    background: transparent;
    font-size: 16px;
    font-weight: 600;
    line-height: 34px;
    color: #f5f5f5;
    text-align: center;
}
.faq .btn-faq:hover {
    text-decoration: none;
}

.faq-inner .faq-wrap {
    width: 100%;
    /* padding: 10px 20px 10px 40px; */
    border-bottom: 1px solid #ebebeb;
    position: relative;
    color: #fff;
}
.faq-inner .faq-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 80px;
    border: none;
    border-top: 1px solid #9da0a4;
    background: none;
    padding: 0 22px 0 13px;
    font-size: 20px;
    font-weight: 400;
    line-height: 40px;
    color: #fff;
}
.faq-inner .question {
    margin-right: 20px;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
}
.faq-inner .card-title {
    margin: 0;
}
.faq-inner .faq-content {
    width: 100%;
    overflow: hidden;
}
.faq-content .inner {
    margin-bottom: 20px;
    padding: 34px 40px;
    border-radius: 20px;
    background: #2c2e2f;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    color: #fff;
}
.accordion-enter-active,
.accordion-leave-active {
    will-change: height, opacity;
    transition: height 0.8s ease, opacity 0.8s ease;
    overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
    height: 0 !important;
    opacity: 0;
}
.line {
    width: 100%;
    height: 1px;
    background: #9da0a4;
}

@keyframes fadeInUp {
    0% {
        opacity: 0;
        height: 0;
    }
    to {
        opacity: 1;
        height: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pc_partners/FaQ.vue